export default class UrlBuilder {
    url;
    constructor(url) {
        this.url = new URL(url);
    }
    toString = () => {
        return this.url.toString();
    };
    addPagination = (offset, limit) => {
        if (offset) {
            this.url.searchParams.append('offset', offset);
        }
        if (limit) {
            this.url.searchParams.append('limit', limit);
        }
        return this;
    };
    addSorting = (sorter) => {
        if (sorter) {
            const sortBy =
                sorter.column.key !== 'company_uuid'
                    ? sorter.column.key
                    : 'customer';
            const sortOrder = sorter.order === 'ascend' ? 'asc' : 'dsc';

            this.url.searchParams.append('sort-by', sortBy);
            this.url.searchParams.append('sort-order', sortOrder);
        }
        return this;
    };
}
